/* RoyAI API client — thin wrapper over the shared axios instance. */
import { api } from "@/lib/api";

export const royai = {
  dashboard:  () => api.get("/royai/dashboard").then((r) => r.data),
  hunter:     () => api.get("/royai/hunter").then((r) => r.data),
  audit:      () => api.get("/royai/audit").then((r) => r.data),
  accounting: () => api.get("/royai/accounting").then((r) => r.data),
  forecast:   () => api.get("/royai/forecast").then((r) => r.data),
  alerts:     () => api.get("/royai/alerts").then((r) => r.data),
  insights:   () => api.get("/royai/insights").then((r) => r.data),
  addExpense: (payload) => api.post("/royai/expenses", payload).then((r) => r.data),
  deleteExpense: (id) => api.delete(`/royai/expenses/${id}`).then((r) => r.data),
  deleteRevenueTrack: (trackId) => api.delete(`/royai/revenue-report/${trackId}`).then((r) => r.data),
  updateTrackSplit: (trackId, payload) =>
    api.patch(`/royai/revenue-report/${trackId}/split`, payload).then((r) => r.data),
  reportUrl:  () => `${api.defaults.baseURL}/royai/report.csv`,
  listTracks:  () => api.get("/royai/audit/tracks").then((r) => r.data),
  addTrack:    (payload) => api.post("/royai/audit/tracks", payload).then((r) => r.data),
  deleteTrack: (id) => api.delete(`/royai/audit/tracks/${id}`).then((r) => r.data),
  runAudit:    () => api.post("/royai/audit/run").then((r) => r.data),
  importLink:  (url) => api.post("/royai/audit/import", { url }).then((r) => r.data),
  importScreenshot: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/royai/audit/import-screenshot", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
  revenueReport: () => api.get("/royai/revenue-report").then((r) => r.data),
  bounties:    () => api.get("/royai/bounties").then((r) => r.data),
  dismissBounty: (id) => api.post(`/royai/bounties/${id}/dismiss`).then((r) => r.data),
  catalogSummary: () => api.get("/royai/catalog-summary").then((r) => r.data),
  portfolio: () => api.get("/royai/portfolio").then((r) => r.data),
  finalizePortfolio: () => api.post("/royai/portfolio/finalize").then((r) => r.data),
  saveAnalyzerToAudit: (payload) => api.post("/royai/analyzer/save-to-audit", payload).then((r) => r.data),
  deleteTrack: (trackId) => api.delete(`/royai/audit/tracks/${trackId}`).then((r) => r.data),
};

export const fmtUsd = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export const fmtUsdCents = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);
